import { render, staticRenderFns } from "./icon-wrapper.vue?vue&type=template&id=8dbe0ffa&scoped=true"
import script from "./icon-wrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-wrapper.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./icon-wrapper.vue?vue&type=style&index=0&id=8dbe0ffa&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbe0ffa",
  null
  
)

export default component.exports